import React from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux';
import moment from 'moment';
//import MaterialTable from 'material-table';

import { ReportDescriptionTable } from './ReportDescriptionTable';
import { ReportAlarmTables } from './ReportAlarmTables';
import { BarChartGroup } from '../charts/BarChartGroup';
import { Title } from '../ui/Title';
import { ReportDistanceTable } from './ReportDistanceTable';
import { ReportStormTable } from './ReportStormTable';
import { useStyles } from './reportStyles';
import { ReportChartsLights } from './ReportChartsLights';
import '../charts/css/chartPrint.css';
import './css/reportPrint.css'


export const ReportPrintScreen = () => {

    const classes = useStyles();
    const { startDate, endDate, namePoint, data } = useSelector(state => state.print)
    const { 7: validation } = data;
    const numberPrint = 6;
    const { name } = useSelector(state => state.auth)
    const user = name.toUpperCase()
    const today = moment().format('YYYY-MM-DD HH:mm:ss a').toString()


    return (
        <>
            <Grid item container spacing={3} xs={12} md={12} lg={12} id='op1'>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'center' }} id='titleReport'>
                    <Typography component="h3" variant="h6" >
                        SISTEMA DE ALERTAS TORMENTAS ELÉCTRICAS {namePoint}
                    </Typography>
                    <Title>Información de alertas</Title>
                    <Typography component="h6" variant="subtitle1">Periodo Consultado</Typography>
                    {!!startDate &&
                        (
                            <Typography component="h6" variant="subtitle1" >
                                {startDate} / {endDate}
                            </Typography>
                        )
                    }

                </Grid>

                <Grid item xs={numberPrint} md={12} lg={6} id='ReportDescriptionTable'>
                    <ReportDescriptionTable />
                </Grid>

                <Grid item xs={numberPrint} md={12} lg={6} id="ReportAlarmTables">
                    <ReportAlarmTables />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <Paper className={classes.paper} >
                        <BarChartGroup />
                    </Paper>
                </Grid>
            </Grid>


            <Grid item container spacing={3} xs={12} md={12} lg={12} id="storm-tables">
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
                    <Title > Actividad de rayos detectada</Title>
                </Grid>
                <Grid item xs={numberPrint} md={12} lg={6}>
                    <Paper className={classes.paper}>
                        <ReportDistanceTable />
                    </Paper>
                </Grid>

                <Grid item xs={numberPrint} md={12} lg={6}>
                    <Paper className={classes.paper}>
                        <ReportStormTable />
                    </Paper>
                </Grid>

                {/* <Grid item xs={12} md={12} lg={12}>
                    <div id="content">
                        <div id="pageFooter">Página 1 </div>
                    </div>
                </Grid> */}



                {validation !== null ?
                    <>
                        <ReportChartsLights />
                        <div >
                            <div>
                                <p>Este reporte ha sido generado automáticamente el {today}, por el usuario: {user}</p>
                            </div>

                            <div className="copy-right">
                                <p>Powered By Keraunos SAS</p>
                            </div>

                        </div>
                    </> :
                    <div >
                        <div>
                            <p>Este reporte ha sido generado automáticamente el {today}, por el usuario: {user}</p>
                        </div>

                        <div className="copy-right">
                            <p>Powered By Keraunos SAS</p>
                        </div>

                    </div>

                }



            </Grid>
        </>
    )
}
